import { createSlice } from "@reduxjs/toolkit";
import { deleteQrTemplate, getAllTemplates, saveQrTemplate } from "../requests";

const qrTemplates = createSlice({
  name: "qrTemplates",
  initialState: {
    templates: [],
    activeQrTemplate: null,
  },
  reducers: {
    setActiveQrTemplate(state, { payload }) {
      state.activeQrTemplate = payload;
    },
  },
  extraReducers: {
    [getAllTemplates.fulfilled]: (state, { payload }) => {
      state.templates = payload.map((item) => ({
        id: item.id,
        ...item.template,
      }));
    },
    [saveQrTemplate.fulfilled]: (state, { payload }) => {
      state.templates.push(payload);
    },
    [deleteQrTemplate.fulfilled]: (state, { payload }) => {
      state.templates = state.templates.filter(
        (template) => template.id !== payload
      );
    },
  },
});
export const { setActiveQrTemplate } = qrTemplates.actions;
export default qrTemplates.reducer;
